var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Wallet } from 'ethers';
import { PrivateKey, TextCodec, } from '../src';
import { promiseWithTimeout } from '../src/utils';
export const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
export function pollFor(callback, timeoutMs, delayMs) {
    return __awaiter(this, void 0, void 0, function* () {
        const started = Date.now();
        try {
            return yield callback();
        }
        catch (err) {
            if (delayMs) {
                yield sleep(delayMs);
            }
            const elapsedMs = Date.now() - started;
            const remainingTimeoutMs = timeoutMs - elapsedMs;
            if (remainingTimeoutMs <= 0) {
                throw new Error('timeout exceeded');
            }
            return yield pollFor(callback, remainingTimeoutMs, delayMs);
        }
    });
}
export function dumpStream(stream, timeoutMs = 1000) {
    return __awaiter(this, void 0, void 0, function* () {
        const messages = [];
        try {
            while (true) {
                const result = yield promiseWithTimeout(timeoutMs, () => stream.next(), 'timeout');
                if (result.done) {
                    break;
                }
                messages.push(result.value);
            }
        }
        catch (_a) {
        }
        finally {
            stream.return();
        }
        return messages;
    });
}
export function newWallet() {
    const key = PrivateKey.generate();
    if (!key.secp256k1) {
        throw new Error('invalid key');
    }
    return new Wallet(key.secp256k1.bytes);
}
// A helper to replace a full Client in testing custom content types,
// extracting just the codec registry aspect of the client.
export class CodecRegistry {
    constructor() {
        this._codecs = new Map();
        this.registerCodec(new TextCodec());
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    registerCodec(codec) {
        const id = codec.contentType;
        const key = `${id.authorityId}/${id.typeId}`;
        this._codecs.set(key, codec);
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    codecFor(contentType) {
        const key = `${contentType.authorityId}/${contentType.typeId}`;
        return this._codecs.get(key);
    }
}
//# sourceMappingURL=helpers.js.map